import { render, staticRenderFns } from "./paper-result-new-practice.vue?vue&type=template&id=64f5e15e&scoped=true"
import script from "./paper-result-new-practice.vue?vue&type=script&lang=ts"
export * from "./paper-result-new-practice.vue?vue&type=script&lang=ts"
import style0 from "./paper-result-new-practice.vue?vue&type=style&index=0&id=64f5e15e&prod&lang=scss&scoped=true"
import style1 from "./paper-result-new-practice.vue?vue&type=style&index=1&id=64f5e15e&prod&lang=scss&scoped=true"
import style2 from "./paper-result-new-practice.vue?vue&type=style&index=2&id=64f5e15e&prod&lang=scss"
import style3 from "./paper-result-new-practice.vue?vue&type=style&index=3&id=64f5e15e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5e15e",
  null
  
)

export default component.exports